export default function generateUniqueName(documentClient: string) {
  const document = documentClient.length > 0 ? documentClient : 'Sem_documento'
  const currentDate = new Date()
  const formattedDate = currentDate.toISOString().slice(0, 10).replace(/-/g, '')
  const currentTime = currentDate.toTimeString().slice(0, 8)

  const uniqueName = `${document}_${formattedDate}_${currentTime}`
  return uniqueName
}
